import { regionHubs } from "../data/site";

// Datenschutzfreundliche, schematische Darstellung der Schwerpunktregionen.
// Keine festen Grenzen, kein externer Kartendienst, kein Tracking.
export default function RegionMap() {
  const cx = 300;
  const cy = 220;
  const nodes = regionHubs.slice(0, 10).map((r, i) => {
    const angle = (Math.PI * 2 * i) / regionHubs.length - Math.PI / 2;
    const radius = 150 + (i % 2) * 26;
    return {
      ...r,
      x: cx + Math.cos(angle) * radius,
      y: cy + Math.sin(angle) * radius * 0.62,
    };
  });

  return (
    <div className="relative overflow-hidden rounded-md border border-dark-gray bg-brand-black p-6 md:p-8" data-testid="region-map">
      <svg viewBox="0 0 600 440" className="h-auto w-full" role="img" aria-label="Schematische Übersicht der Schwerpunktregionen">
        {/* orientation rings */}
        {[190, 130, 70].map((r) => (
          <ellipse key={r} cx={cx} cy={cy} rx={r} ry={r * 0.62} fill="none" stroke="#292929" strokeWidth="1" strokeDasharray="4 6" />
        ))}
        {/* connectors */}
        {nodes.map((n) => (
          <line key={`l-${n.slug}`} x1={cx} y1={cy} x2={n.x} y2={n.y} stroke="#292929" strokeWidth="1" />
        ))}
        {/* center = Sitz */}
        <circle cx={cx} cy={cy} r="8" fill="#FFD400" />
        <text x={cx} y={cy + 26} textAnchor="middle" fill="#F4F4F4" fontSize="12" fontWeight="700">Sitz: Altenstadt</text>
        {/* region nodes */}
        {nodes.map((n) => (
          <g key={n.slug}>
            <circle cx={n.x} cy={n.y} r="5" fill="#FFD400" />
            <text
              x={n.x}
              y={n.y - 10}
              textAnchor={n.x < cx - 20 ? "end" : n.x > cx + 20 ? "start" : "middle"}
              fill="#FFFFFF"
              fontSize="11"
              fontWeight="600"
            >
              {n.short}
            </text>
          </g>
        ))}
      </svg>
      <p className="mt-2 text-center text-xs text-light-gray/50">
        Schematische Orientierung – keine verbindlichen Grenzen. Einsätze auch darüber hinaus möglich.
      </p>
    </div>
  );
}
